module.exports = __webpack_public_path__ + "static/media/location-pin-generic.4d0eb0ce.svg";